// src/utils/responseUtils.ts
var responseStatusCodesWithoutBody = [204, 205, 304];

export {
  responseStatusCodesWithoutBody
};
